import { types } from "../../types/types";
import { ESTUDIOS_MEDICOS_ESTADOS } from "../../utils/constants";

const initialState = {
  afiliadoSeleccionado: null,
  afiliado: [],
  estadoEstudiosMedicos: ESTUDIOS_MEDICOS_ESTADOS.ENFERMERIA?.toString(),
  showForm: true,
  estudiosMedicos: [],
  estudiosMedicosContadores: [],
  estudioMedicoSeleccionado: null,
  estados: [],
  informes: [],
  tracking: [],
  notas: [],
  tiposNotas: []
};

export const EstudiosMedicosReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.estudiosMedicosClearReducer:
      return {
        ...initialState,
      };
    case types.estudiosMedicosUpdateEstado:
      return {
        ...state,
        estadoEstudiosMedicos: action.payload,
      };
    case types.estudiosMedicosSetAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: action.payload,
      };
    case types.estudiosMedicosCleanAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: null,
      }
    case types.estudiosMedicosSetAfiliado:
      return {
        ...state,
        afiliado: action.payload,
      };
    case types.estudiosMedicosCleanAfiliado:
      return {
        ...state,
        afiliado: null,
      }
    case types.estudiosMedicosUpdateAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: action.payload,
      };
    case types.estudiosMedicosGetSuccess:
      return {
        ...state,
        estudiosMedicos: action.payload,
      };
    case types.estudiosMedicosClean:
      return {
        ...state,
        estudiosMedicos: [],
      };
    case types.estudiosMedicosGetError:
      return {
        ...state,
        estudiosMedicos: [],
      };
    case types.estudiosMedicosGetContadoresSuccess:
      return {
        ...state,
        estudiosMedicosContadores: action.payload,
      };
    case types.estudiosMedicosGetContadoresError:
      return {
        ...state,
        estudiosMedicosContadores: [],
      };
    case types.estudiosMedicosSetSeleccionado:
      return {
        ...state,
        estudioMedicoSeleccionado: action.payload,
      };
    case types.estudiosMedicosUpdatePorid:
      return {
        ...state,
        estudiosMedicos: state.estudiosMedicos.map((item) =>
          item.id === action.payload.id
            ? action.payload
            : item
        ),
      };
    case types.estadosEstudiosMedicosGetSuccess:
      return {
        ...state,
        estados: action.payload,
      };
    case types.estadosEstudiosMedicosGetError:
      return {
        ...state,
        estados: [],
      };
    case types.informesMedicosGetSuccess:
      return {
        ...state,
        informes: action.payload,
      };
    case types.informesMedicosGetError:
      return {
        ...state,
        informes: [],
      };
    case types.trackingEstudiosMedicosGetSuccess:
      return {
        ...state,
        tracking: action.payload,
      };
    case types.trackingEstudiosMedicosGetError:
      return {
        ...state,
        tracking: [],
      };
    case types.notasEstudiosMedicosGetSuccess:
      return {
        ...state,
        notas: action.payload,
      };
    case types.notasEstudiosMedicosGetError:
      return {
        ...state,
        notas: [],
      };
    case types.tipoNotasEstudiosMedicosGetSuccess:
      return {
        ...state,
        tiposNotas: action.payload,
      };
    case types.tipoNotasEstudiosMedicosGetError:
      return {
        ...state,
        tiposNotas: [],
      };
    default:
      return state;
  }

};
